module.exports = __webpack_public_path__ + "img/homepage_mobile.f3b88562.png";